module.exports = __webpack_public_path__ + "static/img/Bachelor_010698.83fa444.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Bachelor_010698.jpg
// module id = 224
// module chunks = 0